export const COFFEE_API_BASE = '/api/coffee/v2';

export const coffeeRatingPaths = {
    list: () => `${COFFEE_API_BASE}/ratings`,
    create: () => `${COFFEE_API_BASE}/ratings`,
    byIds: () => `${COFFEE_API_BASE}/ratings/by-ids`,
    favoriteTypes: () => `${COFFEE_API_BASE}/ratings/favorite-types`,
    byId: (id: string) => `${COFFEE_API_BASE}/ratings/${id}`,
    image: (id: string) => `${COFFEE_API_BASE}/ratings/${id}/image`,
    voice: (id: string) => `${COFFEE_API_BASE}/ratings/${id}/voice`,
    status: (id: string) => `${COFFEE_API_BASE}/ratings/${id}/status`,
    createSupermarket: () => `${COFFEE_API_BASE}/ratings/supermarket`,
};

export const coffeeBrandPaths = {
    list: () => `${COFFEE_API_BASE}/brands`,
    search: () => `${COFFEE_API_BASE}/brands/search`,
    create: () => `${COFFEE_API_BASE}/brands`,
    types: (idOrSlug: string) => `${COFFEE_API_BASE}/brands/${idOrSlug}/types`,
    proposeType: (idOrSlug: string) => `${COFFEE_API_BASE}/brands/${idOrSlug}/types`,
    // admin moderation
    pending: () => `${COFFEE_API_BASE}/brands/pending`,
    approve: (id: string) => `${COFFEE_API_BASE}/brands/${id}/approve`,
    reject: (id: string) => `${COFFEE_API_BASE}/brands/${id}/reject`,
    approveType: (id: string, key: string) => `${COFFEE_API_BASE}/brands/${id}/types/${key}/approve`,
    rejectType: (id: string, key: string) => `${COFFEE_API_BASE}/brands/${id}/types/${key}/reject`,
};

export const coffeeMachinePaths = {
    list: () => `${COFFEE_API_BASE}/machines`,
    create: () => `${COFFEE_API_BASE}/machines`,
    byId: (id: string) => `${COFFEE_API_BASE}/machines/${id}`,
    deactivate: (id: string) => `${COFFEE_API_BASE}/machines/${id}/deactivate`,
};

export const coffeeBeanPaths = {
    list: () => `${COFFEE_API_BASE}/beans`,
    create: () => `${COFFEE_API_BASE}/beans`,
    byId: (id: string) => `${COFFEE_API_BASE}/beans/${id}`,
    deactivate: (id: string) => `${COFFEE_API_BASE}/beans/${id}/deactivate`,
};

export const coffeeCapsulePaths = {
    list: () => `${COFFEE_API_BASE}/capsules`,
    create: () => `${COFFEE_API_BASE}/capsules`,
    byId: (id: string) => `${COFFEE_API_BASE}/capsules/${id}`,
    deactivate: (id: string) => `${COFFEE_API_BASE}/capsules/${id}/deactivate`,
};

export const coffeeMasterPaths = {
    me: () => `${COFFEE_API_BASE}/coffee-master/me`,
    request: () => `${COFFEE_API_BASE}/coffee-master/request`,
    requests: () => `${COFFEE_API_BASE}/coffee-master/requests`,
    approve: (id: string) => `${COFFEE_API_BASE}/coffee-master/requests/${id}/approve`,
    reject: (id: string) => `${COFFEE_API_BASE}/coffee-master/requests/${id}/reject`,
};

export const coffeeTypePaths = {
    list: () => `${COFFEE_API_BASE}/types`,
    withCounts: () => `${COFFEE_API_BASE}/types/with-counts`,
    requests: () => `${COFFEE_API_BASE}/types/requests`,
};

export const coffeeAdminPaths = {
    coffees: () => `${COFFEE_API_BASE}/admin/coffees`,
    coffeeById: (id: string) => `${COFFEE_API_BASE}/admin/coffees/${id}`,
    toggle: (id: string) => `${COFFEE_API_BASE}/admin/coffees/${id}/toggle`,
    icons: () => `${COFFEE_API_BASE}/admin/icons`,
};

export const coffeeShopPaths = {
    list: () => `${COFFEE_API_BASE}/shops`,
    nearby: () => `${COFFEE_API_BASE}/shops/nearby`,
    mapData: () => `${COFFEE_API_BASE}/shops/map/data`,
    byCluster: (clusterId: string) => `${COFFEE_API_BASE}/shops/by-cluster/${clusterId}`,
    searchGoogle: () => `${COFFEE_API_BASE}/shops/search-google`,
    propose: () => `${COFFEE_API_BASE}/shops/propose`,
    byId: (id: string) => `${COFFEE_API_BASE}/shops/${id}`,
    archive: (id: string) => `${COFFEE_API_BASE}/shops/${id}/archive`,
    recommend: () => `${COFFEE_API_BASE}/shops/recommend`,
    recommendations: () => `${COFFEE_API_BASE}/shops/recommendations`,
};

export const coffeeClusterPaths = {
    list: () => `${COFFEE_API_BASE}/clusters`,
    create: () => `${COFFEE_API_BASE}/clusters`,
    byId: (id: string) => `${COFFEE_API_BASE}/clusters/${id}`,
    boundaries: () => `${COFFEE_API_BASE}/clusters/map/boundaries`,
    grid: () => `${COFFEE_API_BASE}/clusters/map/grid`,
    unclaimedNeighbors: () => `${COFFEE_API_BASE}/clusters/map/unclaimed-neighbors`,
    fetch: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/fetch`,
    refresh: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/refresh`,
    suggestSplit: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/suggest-split`,
    split: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/split`,
    fetchEstimate: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/fetch-estimate`,
    search: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/search`,
    addPlaces: (id: string) => `${COFFEE_API_BASE}/clusters/${id}/add-places`,
};

export const coffeeChainPaths = {
    list: () => `${COFFEE_API_BASE}/chains`,
    create: () => `${COFFEE_API_BASE}/chains`,
    byId: (id: string) => `${COFFEE_API_BASE}/chains/${id}`,
    assign: (chainId: string) => `${COFFEE_API_BASE}/chains/${chainId}/assign`,
    unassign: (chainId: string) => `${COFFEE_API_BASE}/chains/${chainId}/unassign`,
    searchShops: (chainId: string) => `${COFFEE_API_BASE}/chains/${chainId}/search-shops`,
    shops: (chainId: string) => `${COFFEE_API_BASE}/chains/${chainId}/shops`,
    rules: (chainId: string) => `${COFFEE_API_BASE}/chains/${chainId}/rules`,
    ruleById: (chainId: string, ruleId: string) => `${COFFEE_API_BASE}/chains/${chainId}/rules/${ruleId}`,
    runRules: () => `${COFFEE_API_BASE}/chains/run-rules`,
};

export const coffeeShopReviewPaths = {
    pending: () => `${COFFEE_API_BASE}/shop-review/pending`,
    stats: () => `${COFFEE_API_BASE}/shop-review/stats`,
    approve: (id: string) => `${COFFEE_API_BASE}/shop-review/${id}/approve`,
    quickApprove: (id: string) => `${COFFEE_API_BASE}/shop-review/${id}/quick-approve`,
    reject: (id: string) => `${COFFEE_API_BASE}/shop-review/${id}/reject`,
    searchGoogle: (id: string) => `${COFFEE_API_BASE}/shop-review/${id}/search-google`,
    linkPlace: (id: string) => `${COFFEE_API_BASE}/shop-review/${id}/link-place`,
    update: (id: string) => `${COFFEE_API_BASE}/shop-review/${id}/update`,
};
